module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Semibold.e570ec81.otf";